<template>
  <v-card elevation="0" class="px-4">
    <v-divider></v-divider>

    <div class="d-flex justify-space-between mt-6">
      <div class="d-flex align-center" style="gap: 16px; flex: 1;">
        <v-text-field 
          style="max-width: 400px" 
          v-model="search" 
          append-icon="mdi-magnify" 
          outlined
          label="Buscar" 
          single-line 
          dense 
          hide-details>
        </v-text-field>

        <div :class="selectedProfile ? '' : '--ballooom'">
          <span>
            <v-autocomplete v-model="selectedProfile" :items="profileOptions" item-text="display_name"
              item-value="uri" outlined dense clearable :loading="loadingProfiles" :disabled="loadingProfiles"
              placeholder="Selecione um inventário..."
              :style="$vuetify.breakpoint.width >= 1000 ? 'min-width: 370px; max-width: 470px' : 'width: 100%'"
              @change="onProfileChange" @input="onProfileInput" hide-details no-data-text="Nenhum inventário encontrado">
              <template v-slot:item="{ item }">
                <v-list-item-content>
                  <v-list-item-title>{{ item.display_name }}</v-list-item-title>
                </v-list-item-content>
              </template>
            </v-autocomplete>
          </span>
          <div v-if="!selectedProfile && !loadingProfiles">
            Selecione um inventário para listar os formatos
          </div>
        </div>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              color="primary"
              outlined
              class="materials-btn"
              @click="materialsDialog = true">
              <v-icon left small>mdi-folder-upload-outline</v-icon>
              Enviar Materiais
            </v-btn>
          </template>
          <span>Enviar mídia kit, tabela de preços e materiais complementares</span>
        </v-tooltip>

        <div v-if="selectedProfile && !loadingProfiles" class="d-flex align-center" style="gap: 12px;">
          <div class="text-body-2" style="max-width: 380px;">
            Caso todos os preços e audiências dos <strong>{{ activeFormatsCount }} formatos ativos</strong> já estiverem atualizados, valide os dados:
          </div>
          <v-tooltip bottom :disabled="!alreadyValidatedToday">
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on">
                <v-btn
                  :color="alreadyValidatedToday ? 'grey lighten-1' : 'success'"
                  :dark="!alreadyValidatedToday"
                  elevation="2"
                  :class="{ 'validated-btn': alreadyValidatedToday }"
                  @click="!alreadyValidatedToday && openValidateDialog()"
                  :loading="validatingData"
                  :style="alreadyValidatedToday ? 'pointer-events: auto; opacity: 0.7;' : ''">
                  <v-icon left small>{{ alreadyValidatedToday ? 'mdi-check-all' : 'mdi-check-circle' }}</v-icon>
                  {{ alreadyValidatedToday ? 'Já validado hoje' : 'Validar dados' }}
                </v-btn>
              </span>
            </template>
            <span>Dados já validados hoje para este inventário</span>
          </v-tooltip>
        </div>
      </div>

      <div class="d-flex align-center">
        <div class="text-subtitle-1 font-weight-medium mr-4">
          Total de Formatos: <span class="primary--text font-weight-bold">{{ formats.length }}</span>
        </div>
        <!-- <v-btn 
          @click="addFormat()" 
          class="py-5 ml-2 mb-1" 
          color="success" 
          outlined>
          Adicionar com base em modelo
        </v-btn>
        <v-btn 
          @click="addNewFormat()" 
          class="py-5 ml-2 mb-1" 
          color="success" 
          elevation="0">
          Adicionar
        </v-btn> -->
      </div>
    </div>

    <v-card outlined class="mt-4">
      <v-data-table
        :headers="headers"
        :items="formats"
        :items-per-page="5"
        :search="search"
        :loading="loading"
        loading-text="Carregando formatos...">
        
        <template v-slot:[`item.inventario`]="{ item }">
          <div class="d-flex align-center" style="gap: 6px;">
            {{ item.inventario }}
            <v-btn icon x-small @click="openInfoDialog(item)" title="Informações do formato">
              <v-icon small color="primary">mdi-information-outline</v-icon>
            </v-btn>
          </div>
        </template>

        <template v-slot:[`item.formato`]="{ item }">
          {{ item.formato }}
        </template>

        <template v-slot:[`item.bucket`]="{ item }">
          {{ item.bucket }}
        </template>

        <template v-slot:[`item.codigoInterno`]="{ item }">
          {{ item.codigoInterno }}
        </template>

        <template v-slot:[`item.tipoMidia`]="{ item }">
          {{ item.tipoMidia }}
        </template>

        <template v-slot:[`item.precoRotulo`]="{ item }">
          {{ item.precoRotulo }}
        </template>

        <template v-slot:[`item.periodicidade`]="{ item }">
          {{ item.periodicidade }}
        </template>

        <template v-slot:[`item.audiencia`]="{ item }">
          {{ item.audiencia }}
        </template>

        <template v-slot:[`item.criadoEm`]="{ item }">
          {{ item.criadoEm }}
        </template>

        <template v-slot:[`item.status`]="{ item }">
          <v-chip 
            label 
            small 
            class="mx-2" 
            :color="item.status === 'Ativo' ? 'success' : 'red'"
            :dark="item.status !== 'Ativo'">
            {{ item.status }}
          </v-chip>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <v-btn icon @click="editFormat(item)">
            <v-icon small>mdi-pencil</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>

    <v-dialog v-model="infoDialog" max-width="960" scrollable>
      <v-card v-if="selectedFormatRaw" class="info-dialog-card">

        <div class="info-dialog-header">
          <div class="d-flex align-center" style="gap: 14px; flex: 1; min-width: 0;">
            <v-avatar size="48" tile rounded color="grey lighten-3">
              <v-img v-if="selectedFormatRaw.logo" :src="selectedFormatRaw.logo" contain></v-img>
              <v-icon v-else color="grey lighten-1" size="28">mdi-radio-tower</v-icon>
            </v-avatar>
            <div style="min-width: 0;">
              <div class="text-caption grey--text text--darken-1 mb-1" style="letter-spacing: .06em; text-transform: uppercase; font-weight: 600;">
                {{ selectedFormatRaw.display_name }}
              </div>
              <div class="text-subtitle-1 font-weight-bold" style="line-height: 1.3; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                {{ selectedFormatRaw.asus && selectedFormatRaw.asus.title }}
              </div>
              <div class="d-flex align-center mt-1" style="gap: 6px; flex-wrap: wrap;">
                <v-chip x-small label outlined color="primary" v-if="selectedFormatRaw.asus && selectedFormatRaw.asus.sku">
                  {{ selectedFormatRaw.asus.sku }}
                </v-chip>
                <v-chip x-small label color="blue-grey lighten-4"
                  v-if="selectedFormatRaw.asus && selectedFormatRaw.asus.bucket && selectedFormatRaw.asus.bucket.length">
                  {{ selectedFormatRaw.asus.bucket[0].title }}: {{ selectedFormatRaw.asus.bucket[0].name }}
                </v-chip>
                <v-chip x-small label color="blue-grey lighten-4"
                  v-if="selectedFormatRaw.asus && selectedFormatRaw.asus.media_type && selectedFormatRaw.asus.media_type.length">
                  {{ selectedFormatRaw.asus.media_type[0].parents[0] }}
                </v-chip>
              </div>
            </div>
          </div>
          <v-btn icon small @click="infoDialog = false" class="ml-2">
            <v-icon size="20">mdi-close</v-icon>
          </v-btn>
        </div>

        <v-tabs v-model="infoTab" background-color="white" color="primary" class="info-dialog-tabs">
          <v-tab>
            <v-icon left small>mdi-information-outline</v-icon>
            Informações Gerais
          </v-tab>
          <v-tab>
            <v-icon left small>mdi-map-marker-outline</v-icon>
            Localidades
          </v-tab>
        </v-tabs>
        <v-divider></v-divider>

        <v-tabs-items v-model="infoTab" style="background: #f8f9fb;">
          <v-tab-item>
            <about-tab :item="selectedFormatRaw"></about-tab>
          </v-tab-item>
          <v-tab-item>
            <map-tab :item="selectedFormatRaw"></map-tab>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-dialog>

    <v-dialog v-model="validateDialog" max-width="440">
      <v-card>
        <v-card-title class="text-subtitle-1 font-weight-bold">
          <v-icon left color="warning">mdi-alert-circle-outline</v-icon>
          Confirmar validação
        </v-card-title>
        <v-card-text>
          Você confirma que todos os preços e audiências dos <strong>{{ activeFormatsCount }} formatos ativos</strong> deste inventário estão atualizados e deseja validar os dados?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="validateDialog = false">Cancelar</v-btn>
          <v-btn color="success" elevation="0" @click="confirmValidateData" :loading="validatingData">
            <v-icon left small>mdi-check-circle</v-icon>
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="editDialog" max-width="700">
      <v-card>
        <v-card-title>
          Editar Formato
        </v-card-title>
        <v-card-text>
          <v-alert type="info" text dense class="mb-4">
            <div class="d-flex justify-space-between align-center">
              <strong>{{ editedFormat.formato }}</strong>
              <div class="text-right">
                <div class="text-body-2 font-weight-medium">{{ editedFormat.bucket }}</div>
              </div>
            </div>
          </v-alert>

          <v-row class="mt-2">
                  <v-col cols="12">
              <v-divider class="my-2"></v-divider>
              <label class="text-subtitle-2 mb-1 d-block">Precificação
              </label>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model.number="editedFormat.unity_price"
                label="Preço de tabela"
                outlined
                dense
                hide-details
                type="number"
                step="0.01"
                :rules="[v => v >= 0 || 'Valor deve ser positivo']">
                <template v-slot:[`prepend-inner`]>
                  <span class="pt-1 text-subtitle-2">R$ </span>
                </template>
              </v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model.number="editedFormat.discount"
                label="Desconto inicial (%)"
                outlined
                dense
                hide-details
                type="number"
                step="0.01"
                :rules="[v => v >= 0 && v <= 100 || 'Entre 0 e 100']">
                <template v-slot:[`append`]>
                  <span class="pt-1">%</span>
                </template>
              </v-text-field>
            </v-col>

                 <v-col cols="12">
              <div >
                <label class="text-subtitle-2 mb-2 d-block">Tipo de Preço</label>
                <v-switch
                  :input-value="priceType === 'bruto'"
                  @change="priceType = $event ? 'bruto' : 'liquido'"
                  :label="priceType === 'bruto' ? 'Valor Bruto' : 'Valor Líquido'"
                  color="primary"
                  hide-details
                  class="mt-0">
                </v-switch>
              </div>
            </v-col>

            <v-col cols="12">
          <div class="d-flex justify-space-between align-center pa-3 grey lighten-4 rounded">
            <strong>Preço para o cliente:</strong>
            <span class="text-h6 black--text font-weight-bold">{{ $n(calculatedFinalPrice, 'currency') }}</span>
          </div>
            </v-col>

            <v-col cols="12">
              <v-divider class="my-2"></v-divider>
              <label class="text-subtitle-2 mb-1 d-block">Audiência</label>
            </v-col>

            <v-col cols="12" md="4">
              <v-text-field
                v-model.number="audienceData.value"
                label="Valor"
                outlined
                dense
                hide-details
                type="number"
                step="1">
              </v-text-field>
            </v-col>

            <v-col cols="12" md="4">
              <v-select
                v-model="audienceData.multiple"
                :items="audiencePeriodOptions"
                item-text="text"
                item-value="value"
                label="Período de audiência"
                outlined
                dense
                hide-details>
              </v-select>
            </v-col>

            <v-col cols="12" md="4">
              <v-text-field
                v-model.number="audienceData.label"
                label="Rótulo"
                outlined
                dense
                hide-details
                type="text">
              </v-text-field>
              <!-- <v-autocomplete
                v-model="audienceData.label"
                :items="availableAudienceLabels"
                label="Rótulo"
                outlined
                dense
                hide-details
                :loading="loadingLabels"
                no-data-text="Nenhum rótulo disponível"
                placeholder="Digite ou selecione um rótulo">
              </v-autocomplete> -->
              
            </v-col>

            <v-col cols="12">
              <v-divider class="my-2"></v-divider>
              <label class="text-subtitle-2 mb-1 d-block">Status</label>
            </v-col>

            <v-col cols="12">
              <v-switch
                v-model="formatStatus"
                :label="formatStatus ? 'Ativo' : 'Inativo'"
                color="success"
                hide-details
                class="mt-0">
              </v-switch>
            </v-col>

          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeEditDialog">
            Cancelar
          </v-btn>
          <v-btn 
            color="success" 
            elevation="0" 
            @click="saveFormat"
            :loading="saving">
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ProviderMaterialsModal v-model="materialsDialog" />
  </v-card>
</template>

<script>
import { showSuccess, showError, showSuccessWithAction } from '@/plugins/snackbar-helper'
import AboutTab from "@/components/InfoBoards/AboutTab.vue";
import MapTab from "@/components/InfoBoards/MapTab.vue";
import ProviderMaterialsModal from "@/components/inventory/ProviderMaterialsModal.vue";

export default {
  name: "FormatsList",
  components: { AboutTab, MapTab, ProviderMaterialsModal },
  data() {
    return {
      materialsDialog: false,
      loadingProfiles: false,
      search: "",
      loading: false,
      saving: false,
      validatingData: false,
      validateDialog: false,
      validatedProfiles: {},
      editDialog: false,
      infoDialog: false,
      infoTab: 0,
      selectedFormatRaw: null,
      priceType: 'liquido',
      formatStatus: true,
      selectedProfile: null,
      profileOptions: [],
      mediaStyleLabels: {},
      loadingLabels: false,
      audienceData: {
        type: 'audience',
        value: 0,
        label: '',
        multiple: ''
      },
      audiencePeriodOptions: [
        { text: 'Não se aplica', value: 'NA' },
        { text: 'Minutos', value: 'I' },
        { text: 'Horas', value: 'H' },
        { text: 'Diário', value: 'D' },
        { text: 'Semanal', value: 'W' },
        { text: 'Mensal', value: 'M' },
        { text: 'Anual', value: 'Y' },
        { text: 'Igual ao formato', value: 'NN' }
      ],
      editedFormat: {
        id: null,
        sku: "",
        uri: "",
        formato: "",
        unity_price: 0,
        markup: 1,
        discount: 0,
        discount_negotiation: 0,
        precoFinal: 0,
        status: "",
        lojas: "",
        codigoInterno: "",
        criadoEm: "",
        criadoEmTimestamp: 0,
        mediaTypeParent: null
      },
      headers: [
        {
          text: "Inventário",
          align: "center",
          sortable: true,
          value: "inventario",
        },
        {
          text: "Formato",
          align: "center",
          sortable: true,
          value: "formato",
        },
        {
          text: "Bucket",
          align: "center",
          sortable: true,
          value: "bucket",
        },
        {
          text: "Código interno",
          align: "center",
          sortable: true,
          value: "codigoInterno",
        },
        {
          text: "Tipo de Mídia",
          align: "center",
          sortable: true,
          value: "tipoMidia",
        },
        {
          text: "Preço",
          align: "start",
          sortable: true,
          value: "precoRotulo",
        },
        {
          text: "Periodicidade",
          align: "center",
          sortable: true,
          value: "periodicidade",
        },
        {
          text: "Audiência",
          align: "center",
          sortable: true,
          value: "audiencia",
        },
        {
          text: "Última atualização",
          align: "center",
          sortable: true,
          value: "criadoEm",
        },
        {
          text: "Status",
          align: "center",
          sortable: true,
          value: "status",
        },
        { 
          text: "", 
          value: "actions", 
          sortable: false,
          align: "end"
        }
      ],
      formats: [],
    };
  },
  mounted() {
    this.loadingProfiles = true
    this.loadProfiles();
    this.loadMediaStyleLabels();
    if (this.$route.query.materials) {
      this.materialsDialog = true;
    }
  },
  methods: {
    async loadMediaStyleLabels() {
      try {
        this.loadingLabels = true;
        const response = await this.$axios.get('/settings/media_style_labels');
        if (response.data && response.data.data && response.data.data.value) {
          this.mediaStyleLabels = response.data.data.value;
        }
      } catch (error) {
        console.error('Erro ao carregar labels de audiência:', error);
      } finally {
        this.loadingLabels = false;
      }
    },
    async loadProfiles() {
      try {
        this.loadingProfiles = true;
        const response = await this.$axios.get(`profiles/inventories`);

        if (response.data && response.data.data) {
          const profilesData = response.data.data;
          this.profileOptions = profilesData
           
          const inventoryFromQuery = this.$route.query.inventory;
          
          if (inventoryFromQuery) {
            const matchedProfile = this.profileOptions.find(
              profile => profile.display_name === decodeURIComponent(inventoryFromQuery)
            );
            
            if (matchedProfile) {
              this.selectedProfile = matchedProfile.uri;
              this.$nextTick(() => {
                this.loadFormats();
              });
            }
          } else if (this.profileOptions.length === 1) {
            this.selectedProfile = this.profileOptions[0].uri;
            this.$nextTick(() => {
              this.loadFormats();
            });
          }
        }
      } catch (error) {
        console.error('Erro ao carregar perfis:', error);
        this.messageErrorSnackbar = "Erro ao carregar perfis!";
        this.showSnackbarError = true;
      } finally {
        this.loadingProfiles = false;
      }
    },
    
    onProfileInput(value) {

      if (!value) {
        this.users = [];
      }
    },

    onProfileChange() {
      if (this.selectedProfile) {
        this.loadFormats();
      }
    },
    async loadFormats() {
      if (!this.selectedProfile) {
        console.warn('Nenhum perfil selecionado');
        return;
      }

      this.loading = true;

      try {
        const response = await this.$axios.get(`/asus/uri/${this.selectedProfile}?pp=300&pg=1&order=created_at&asc=-1&mv`);

        
        if (response.data && response.data.data && response.data.data.samples) {
          
          this.formats = response.data.data.samples.map(sample => {
            const asu = sample.asus;
            const format = asu.format;
            const pricing = asu.private_pricing_info;
            
            const formatText = [format.type, format.value, format.metric]
              .filter(Boolean)
              .join(' ');
            
            const unity = pricing.unity_price || 0;
            const markup = pricing.markup || 1;
            const discount = pricing.discount || 0;
            const priceWithMarkup = unity * markup;
            const finalPrice = priceWithMarkup - (priceWithMarkup * (discount / 100));
            
            const bucketText = asu.bucket && asu.bucket.length 
              ? `${asu.bucket[0].title}: ${asu.bucket[0].name}`
              : '-';
            
            const mediaType = asu.media_type && asu.media_type.length
              ? `${asu.media_type[0].parents.join(', ')} - ${asu.media_type[0].media_type.join(', ')}`
              : '-';
            
            const priceLabel = `${this.$n(finalPrice, 'currency')} ${asu.custom_messages?.msg_unit_price || ''}`;
            
            const periodicityMap = {
              'D': { singular: 'dia', plural: 'dias' },
              'W': { singular: 'semana', plural: 'semanas' },
              'M': { singular: 'mês', plural: 'meses' },
              'Y': { singular: 'ano', plural: 'anos' }
            };
            
            const periodicityText = asu.periodicity
              ? (() => {
                  const value = parseInt(asu.periodicity.value);
                  const type = asu.periodicity.type;
                  const unit = periodicityMap[type];
                  const label = value === 1 ? unit?.singular : unit?.plural;
                  return `${value} ${label || type}`;
                })()
              : '-';

        
              let audienceText = '-'
              let periodicityType = ''
              if(asu.audience && asu.audience.length > 0){
                const audienceType = asu.audience[0].multiple;
                switch(audienceType){
                  case 'I': periodicityType = 'minuto'; break;
                  case 'H': periodicityType = 'hora'; break;
                  case 'D': periodicityType = 'dia'; break;
                  case 'W': periodicityType = 'semana'; break;
                  case 'M': periodicityType = 'mês'; break;
                  case 'Y': periodicityType = 'ano'; break;
                  default: periodicityType = ''; break;
                  
                }
                audienceText = asu.audience && asu.audience.length > 0 ? `${this.$n(asu.audience[0].value)} ${asu.audience[0].label || ''}` : '-';
              }
            
            
            return {
              id: sample._id.$oid,
              sku: asu.sku,
              uri: sample.uri,
              rawSample: sample,
              inventario: sample.display_name || sample.uri || '',
              formato: formatText || asu.title || '-',
              bucket: bucketText,
              codigoInterno: asu.asu_client_id || '-',
              tipoMidia: mediaType,
              precoRotulo: priceLabel,
              periodicidade: periodicityText,
              audiencia: audienceText,
              audienceArray: asu.audience || [],
              mediaTypeParent: asu.media_type && asu.media_type.length && asu.media_type[0].parents && asu.media_type[0].parents.length ? asu.media_type[0].parents[0] : null,
              unity_price: pricing.unity_price || 0,
              markup: pricing.markup || 1,
              discount: pricing.discount || 0,
              discount_negotiation: 0,
              precoFinal: finalPrice,
              status: sample.visible ? 'Ativo' : 'Inativo',
              criadoEm: this.formatDate(sample.created_at || sample.createdOn),
              criadoEmTimestamp: sample.created_at?.$date?.$numberLong ? parseInt(sample.created_at.$date.$numberLong) : (sample.created_at?.$date || new Date(sample.created_at || sample.createdOn).getTime())
            };
          }).sort((a, b) => b.criadoEmTimestamp - a.criadoEmTimestamp);
        }
      } catch (error) {
        console.error('Erro ao carregar formatos:', error);
      } finally {
        this.loading = false;
      }
    },
    formatDate(date) {
      if (!date) return '';
      
      const d = date.$date ? new Date(date.$date.$numberLong ? parseInt(date.$date.$numberLong) : date.$date) : new Date(date);
      
      const day = String(d.getDate()).padStart(2, '0');
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const year = String(d.getFullYear()).slice(-2);
      const hours = String(d.getHours()).padStart(2, '0');
      const minutes = String(d.getMinutes()).padStart(2, '0');
      
      return `${day}/${month}/${year} ${hours}:${minutes}`;
    },
    addFormat() {
    },
    addNewFormat() {
    },
    openInfoDialog(item) {
      this.selectedFormatRaw = item.rawSample;
      this.infoTab = 0;
      this.infoDialog = true;
    },
    editFormat(item) {
      this.editedFormat = { ...item };
      this.priceType = item.markup === 1.25 ? 'liquido' : 'bruto';
      this.formatStatus = item.status === 'Ativo';
      
      if (item.audienceArray && item.audienceArray.length > 0) {
        const firstAudience = item.audienceArray[0];
        this.audienceData = {
          type: firstAudience.type || 'audience',
          value: firstAudience.value || 0,
          label: firstAudience.label || '',
          multiple: firstAudience.multiple || ''
        };
      } else {
        this.audienceData = {
          type: 'audience',
          value: 0,
          label: '',
          multiple: ''
        };
      }
      
      console.log('this.audienceData', this.audienceData )
      this.editDialog = true;
    },
    closeEditDialog() {
      this.editDialog = false;
      this.priceType = 'liquido';
      this.formatStatus = true;
      this.audienceData = {
        type: 'audience',
        value: 0,
        label: '',
        multiple: ''
      };
      this.editedFormat = {
        id: null,
        sku: "",
        uri: "",
        formato: "",
        unity_price: 0,
        markup: 1,
        discount: 0,
        discount_negotiation: 0,
        precoFinal: 0,
        status: "",
        lojas: "",
        codigoInterno: "",
        criadoEm: ""
      };
    },
    openValidateDialog() {
      this.validateDialog = true;
    },
    async confirmValidateData() {
      try {
        this.validatingData = true;
        await this.$axios.get(`asus/uri/${this.selectedProfile}/refresh`);
        this.markValidatedToday();
        this.validateDialog = false;
        showSuccess('Dados validados com sucesso!');
        await this.loadFormats();
      } catch (error) {
        console.error('Erro ao validar dados:', error);
        showError('Erro ao validar dados!');
      } finally {
        this.validatingData = false;
      }
    },
    markValidatedToday() {
      const today = new Date().toISOString().slice(0, 10);
      const key = `validated_${this.selectedProfile}`;
      localStorage.setItem(key, today);
      this.$set(this.validatedProfiles, this.selectedProfile, today);
    },
    async saveFormat() {
      if (!this.editedFormat.uri || !this.editedFormat.sku) {
        showError('Dados insuficientes para atualizar o formato')
        return;
      }

      this.saving = true;

      try {
        const markup = this.priceType === 'liquido' ? 1.25 : 1;

        const payload = {
          sku: this.editedFormat.sku,
          unity_price: parseFloat(this.editedFormat.unity_price) || 0,
          markup: markup,
          discount: parseFloat(this.editedFormat.discount) || 0,
          discount_negotiation: parseFloat(this.editedFormat.discount_negotiation) || 0,
          audience: [
            {
              type: this.audienceData.type,
              value: parseInt(this.audienceData.value) || 0,
              label: this.audienceData.label,
              multiple: this.audienceData.multiple
            }
          ],
          status: this.formatStatus ? 1 : 0,
          mv: 1
        };

        await this.$axios.put(`portal/inventory/${this.editedFormat.uri}/pricing`, payload);

        const today = new Date().toISOString().slice(0, 10);
        const celebrationKey = 'pricing_celebration_shown';
        if (localStorage.getItem(celebrationKey) !== today) {
          showSuccessWithAction('🎉 Parabéns! Você atualizou a precificação do formato com sucesso! Esta é uma nova funcionalidade que permite gerenciar seus preços de forma ainda mais eficiente.');
          localStorage.setItem(celebrationKey, today);
        } else {
          showSuccess('Precificação atualizada com sucesso!');
        }

        this.closeEditDialog();
        await this.loadFormats();
      } catch (error) {
        console.error('Erro ao atualizar precificação:', error);
        showError(error.response?.data?.message || 'Erro ao atualizar precificação')
      } finally {
        this.saving = false;
      }
    }
  },
  computed: {
    availableAudienceLabels() {
      if (!this.editedFormat.mediaTypeParent || !this.mediaStyleLabels) {
        return [];
      }
      
      const mediaTypeMap = {
        'Televisão': 'tv',
        'TV': 'tv',
        'Rádio': 'radio',
        'Radio': 'radio',
        'Jornal': 'jornal_revista',
        'Revista': 'jornal_revista',
        'Mídia Exterior': 'ooh',
        'OOH': 'ooh',
        'Out of Home': 'ooh',
        'Online': 'online',
        'Internet': 'online',
        'Digital': 'online',
        'Cinema': 'cinema'
      };
      
      const normalizedParent = this.editedFormat.mediaTypeParent;
      const mappedKey = mediaTypeMap[normalizedParent];
      
      if (mappedKey && this.mediaStyleLabels[mappedKey]) {
        return this.mediaStyleLabels[mappedKey];
      }
      
      return [];
    },
    activeFormatsCount() {
      return this.formats.filter(f => f.status === 'Ativo').length;
    },
    alreadyValidatedToday() {
      if (!this.selectedProfile) return false;
      const today = new Date().toISOString().slice(0, 10);
      if (this.validatedProfiles[this.selectedProfile] === today) return true;
      const key = `validated_${this.selectedProfile}`;
      return localStorage.getItem(key) === today;
    },
    calculatedFinalPrice() {
      const unity = parseFloat(this.editedFormat.unity_price) || 0;
      const markup = this.priceType === 'liquido' ? 1.25 : 1;
      const discount = parseFloat(this.editedFormat.discount) || 0;
      
      const priceWithMarkup = unity * markup;
      const finalPrice = priceWithMarkup - (priceWithMarkup * (discount / 100));
      
      return finalPrice;
    }
  }
}
</script>

<style lang="scss" scoped>
.info-dialog-card {
  overflow: hidden;
}

.info-dialog-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 18px 20px 14px;
  background: #fff;
  border-bottom: 1px solid #e8eaf0;
}

.info-dialog-tabs {
  background: #fff;

  .v-tab {
    font-size: 12px;
    font-weight: 600;
    letter-spacing: .04em;
    text-transform: uppercase;
    min-width: 0;
    padding: 0 20px;
  }
}

.--ballooom {
  position: relative;

  > div {
    background: #33477f;
    color: #fff;
    padding: 9px 15px;
    border-radius: 3px;
    position: absolute;
    z-index: 1;
    top: 30px;
    margin: 10px 10px 0;
    box-shadow: 0 3px 10px rgba(0, 0, 0, .3);

    &:after {
      border-color: rgba(136, 183, 213, 0) !important;
      border-bottom-color: #33477f !important;
      border-width: 10px !important;
      margin-left: -30px !important;
      bottom: 100% !important;
      left: 100%;
      border: solid transparent;
      content: "";
      height: 0;
      width: 0;
      position: absolute;
      pointer-events: none;
    }
  }
}
</style>
